import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NightNeedsListDAL } from '../dal/nightNeedsList.dal';
import { nightNeedsList } from '../models/nightNeedsList.model';

@Injectable({
  providedIn: 'root',
})
export class NightNeedsListService {
  constructor(private nightNeedsListDAL: NightNeedsListDAL) {}

  deleteNightNeedsList(id: string): Observable<any> {
    return this.nightNeedsListDAL.deleteNightNeedsList(id);
  }

  updateNightNeedsList(id: string, cycle: nightNeedsList): Observable<any> {
    return this.nightNeedsListDAL.updateNightNeedsList(id, cycle);
  }

  createNightNeedsList(cycle: nightNeedsList): Observable<any> {
    return this.nightNeedsListDAL.createNightNeedsList(cycle);
  }

  getNightNeedsLists(positions: string): Observable<any> {
    return this.nightNeedsListDAL.getNightNeedsLists(positions);
  }
}
